import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, DrawerBody, DrawerFooter } from '@chakra-ui/react';

import { TabNames } from '../../../../../../../../../../../constants/tabMenuTypes';
import { hideTray } from '../../../../../../../../../../../redux/modules/tray';
import RequirementTemplateBlueprintType from '../../../../../../../../../../../types/RequirementTemplateBlueprintType';
import { REQUIREMENT_TYPES } from '../../../../../../../../../util/options';
import { getCreateRequirementTemplateBlockParams } from '../../../../../../../../../util/util';

import CustomDocumentTypeForm from './CustomDocumentTypeForm';

function CreateCustomDocumentTypeForm({ blueprint }) {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);

  const currentRequirementTemplateBlocks = useSelector(blueprint.selectCurrentRequirementTemplateBlocks);
  const currentEditCustomDocumentTypeId = useSelector(blueprint.selectCurrentEditCustomDocumentId);
  const activeStep = useSelector(blueprint.selectCreateCustomStep(TabNames.Documents));
  const currentRequirementTemplateBlock = useSelector(blueprint.selectCurrentRequirementTemplateBlock);

  let currentMaxOrder = 0;

  useEffect(() => {
    if (currentRequirementTemplateBlocks) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      currentMaxOrder = Math.max(...[0,
        ...currentRequirementTemplateBlocks.map(templateBlock => templateBlock.order)]);
    }
  }, [currentRequirementTemplateBlocks, dispatch]);

  useEffect(() => () => dispatch(blueprint.setEditCustomDocumentId(null)), []);

  const createTemplateBlock = response => {
    if (response?.display_name?.length > 0) {
      dispatch(blueprint.createRequirementTemplateBlock(getCreateRequirementTemplateBlockParams(
        currentMaxOrder,
        REQUIREMENT_TYPES.Documents,
        response
      )));
    }
  };

  const onSubmit = async data => {
    setSubmitting(true);

    const newCustomDocumentInfo = {
      name: data?.name,
      display_name: data?.documentName,
      description: data?.description ?? ''
    };

    if (data?.addToList === false || activeStep === 2) {
      newCustomDocumentInfo.deleted_at = new Date();
    }

    const response = (currentEditCustomDocumentTypeId && activeStep !== 2)
      ? await dispatch(blueprint.updateInsuranceDocumentType(currentEditCustomDocumentTypeId, newCustomDocumentInfo))
      : await dispatch(blueprint.createInsuranceDocumentType(newCustomDocumentInfo));

    if (response && !currentEditCustomDocumentTypeId) {
      createTemplateBlock(response);
    }

    if (response && activeStep === 2) {
      await dispatch(blueprint.deleteRequirementTemplateBlock(currentRequirementTemplateBlock[0].id));
      createTemplateBlock(response);
    }

    setSubmitting(false);
    await dispatch(blueprint.setCreateCustomStep(1, TabNames.Documents));
    await dispatch(blueprint.setEditCustomDocumentId(null));
    await dispatch(blueprint.listInsuranceDocumentTypes());
    dispatch(hideTray());
  };

  return (
    <>
      <DrawerBody>
        <CustomDocumentTypeForm blueprint={blueprint} formId="createCustomDocumentTypeForm" onSubmit={onSubmit} />
      </DrawerBody>
      <DrawerFooter>
        <Button
          form="createCustomDocumentTypeForm"
          isDisabled={submitting}
          type="submit"
          width="100%"
        >
          Save Document
        </Button>
      </DrawerFooter>
    </>
  );
}

CreateCustomDocumentTypeForm.propTypes = {
  blueprint: RequirementTemplateBlueprintType
};

export default CreateCustomDocumentTypeForm;
